import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazySearchOrgsRefinements = clientOnlyLazy(() =>
  import('./SearchOrgsRefinements').then((m) => ({
    default: m.SearchOrgsRefinements,
  })),
);
